module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "recipe",
      "itemscope": "",
      "itemtype": "http://schema.org/Recipe"
    }
  }, [_c('link', {
    attrs: {
      "itemprop": "url",
      "href": 'https://tradfood.fr' + this.$route.fullPath
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "itemprop": "mainEntityOfPage",
      "content": "True"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipe-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.$options.filters.formatUrl(_vm.recipe.image.url),
      "alt": _vm.recipe.name,
      "itemprop": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recipe-details"
  }, [_c('div', {
    staticClass: "recipe-title",
    attrs: {
      "itemprop": "name"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.recipe.name))])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.recipe.description))])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-content"
  }, [_c('div', {
    staticClass: "recipe-details__informations"
  }, [_c('h2', [_vm._v("Informations")]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "itemprop": "recipeYield"
    }
  }, [_vm._v("Nombre de pièces: " + _vm._s(_vm.recipe.servings))]), _vm._v(" "), _c('li', [_c('time', {
    attrs: {
      "itemprop": "prepTime",
      "datetime": 'PT' + _vm.recipe.preparation_time + 'M'
    }
  }, [_vm._v("\n                  Temps de préparation: " + _vm._s(_vm.recipe.preparation_time) + "\n                ")])]), _vm._v(" "), _c('li', [_c('time', {
    attrs: {
      "itemprop": "cookTime",
      "datetime": 'PT' + _vm.recipe.cooking_time + 'M'
    }
  }, [_vm._v("\n                  Temps de cuisson: " + _vm._s(_vm.recipe.cooking_time) + "\n                ")])]), _vm._v(" "), _c('li', [_vm._v("Type de plat: " + _vm._s(_vm.$t(("recipe.filters.mealType." + (_vm.recipe.meal_type.replace(/\s+/g, '-'))))))]), _vm._v(" "), _c('li', [_vm._v("Difficulté: " + _vm._s(_vm.$t(("recipe.filters.difficulty." + (_vm.recipe.difficulty)))))]), _vm._v(" "), _c('li', [_vm._v("Saison: " + _vm._s(_vm.$t(("recipe.filters.season." + (_vm.recipe.season)))))])])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-details__ingredients"
  }, [_c('h2', [_vm._v("Ingredients")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "itemprop": "ingredients"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.compiledMarkdown(_vm.recipe.ingredients))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recipe-details__recipe"
  }, [_c('h2', [_vm._v("Recette")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "itemprop": "recipeInstructions"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.compiledMarkdown(_vm.recipe.recipe))
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tomatoes"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7beff9a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recipe.vue
// module id = 69
// module chunks = 1